export default __webpack_public_path__ + "static/media/group-options-arrow-right.c917a45d.svg";